import { Component } from '@angular/core';

@Component({
  selector: 'app-style-dev',
  templateUrl: './style-dev.component.html',
  styleUrls: ['./style-dev.component.scss'],
})
export class StyleDevComponent {}
